var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18024 0.180242C4.42056 -0.0600807 4.8102 -0.0600807 5.05053 0.180242L12.4351 7.56486C12.6755 7.80518 12.6755 8.19482 12.4351 8.43514L5.05053 15.8198C4.8102 16.0601 4.42056 16.0601 4.18024 15.8198C3.93992 15.5794 3.93992 15.1898 4.18024 14.9495L11.1297 8L4.18024 1.05053C3.93992 0.810205 3.93992 0.420565 4.18024 0.180242Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.1b7a7e532108903a88a7a7e8790589e3.svg";
export { ForwardRef as ReactComponent };